import { Link } from '@lokalise/louis';
import { useLayoutEffect } from 'react';

import Task, { type TaskProps } from './Task';
import { EmptyContainer, NoTasksHeading, NoTasksText, TasksContainer } from './styles';

export type TasksProps = {
    tasks: readonly TaskProps['task'][];
    focusTaskId?: string;
};

const Tasks = ({ tasks, focusTaskId }: TasksProps) => {
    useLayoutEffect(() => {
        if (focusTaskId) {
            document.getElementById(`task:${focusTaskId}`)?.scrollIntoView();
        }
    }, [focusTaskId]);

    if (!tasks.length) {
        return (
            <EmptyContainer>
                <NoTasksHeading>No tasks</NoTasksHeading>
                <NoTasksText>
                    Your incoming tasks will appear here.
                    <br />
                    <Link href="https://docs.lokalise.com/translation-workflow/tasks" target="_new">
                        Learn more
                    </Link>
                </NoTasksText>
            </EmptyContainer>
        );
    }

    return (
        <TasksContainer>
            {tasks.map((task) => (
                <Task key={task.id} task={task} />
            ))}
        </TasksContainer>
    );
};

export default Tasks;
